__webpack_require__.p = "/reports-details-manage-locations/referrals-hub/";